import routerOptions0 from "/home/snaumann/Development/public_html/firmenlauf-potsdam/public/node_modules/.pnpm/nuxt@4.3.1_@parcel+watcher@2.5.6_@vue+compiler-sfc@3.5.28_cac@6.7.14_db0@0.3.4_ioredis@_45f2bb4cff2eba9aace9ed538c4067a6/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/snaumann/Development/public_html/firmenlauf-potsdam/public/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}